module.exports = __webpack_public_path__ + "static/img/saskatoon2.19d93c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/saskatoon2.jpg
// module id = 130
// module chunks = 9